const LogoSvg = (props) => (<svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fillRule="nonzero" d="M28 0c15.464 0 28 12.536 28 28S43.464 56 28 56 0 43.464 0 28 12.536 0 28 0z"/>
      <path fill="#000" fillOpacity=".1" d="M28 1.4C13.31 1.4 1.4 13.31 1.4 28c0 14.69 11.91 26.6 26.6 26.6 14.69 0 26.6-11.91 26.6-26.6C54.6 13.31 42.69 1.4 28 1.4z"/>
      <path fill="#FFF" fillRule="nonzero" d="M22.75 39.295c-1.025 0-1.75-.792-1.75-2.07V18.965c0-1.265.725-2.07 1.75-2.07.467 0 .884.152 1.375.428l14.95 8.831c1.075.652 1.525 1.137 1.525 1.942 0 .804-.45 1.302-1.525 1.94l-14.763 8.723c-.575.345-1.037.537-1.562.537z"/>
    </g>
  </svg>);
export default LogoSvg;
